/* Roku Deney Lab — behavior tracker + homepage experiment attribution.
 *
 * The variant assignment/redirect happens in an inline <head> snippet in
 * theme.liquid (before first paint). This file does the heavy lifting after
 * DOM load: it measures engagement and beacons compact event batches to the
 * Rokumon dashboard API. It also stamps the Shopify cart with the assigned
 * variant so orders can be attributed to the homepage layout that sold them.
 */
(function () {
  'use strict';

  var cfg = window.__rokuLab;
  var pageType = window.__rokuLabPage || 'other';
  if (!cfg || !cfg.endpoint) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (/bot|crawl|spider|lighthouse|headless|preview/i.test(navigator.userAgent)) return;

  // ── variant: set by the head snippet (localStorage) or ?view= preview ──
  var variant = 'control';
  try {
    var viewParam = new URLSearchParams(location.search).get('view');
    if (viewParam && /^rv\d{4}-\d+$/.test(viewParam)) {
      variant = viewParam;
    } else {
      var a = JSON.parse(localStorage.getItem('roku_lab_a') || 'null');
      if (a && a.day === cfg.day && a.v) variant = a.v;
    }
  } catch (e) { /* storage disabled -> control */ }

  // ── session id: 30-minute sliding window ──
  var SID_KEY = 'roku_lab_sid';
  var newSession = false;
  var sid;
  try {
    var s = JSON.parse(localStorage.getItem(SID_KEY) || 'null');
    var now = Date.now();
    if (!s || now - s.ts > 30 * 60 * 1000) {
      sid = 's' + now.toString(36) + Math.random().toString(36).slice(2, 8);
      newSession = true;
    } else {
      sid = s.id;
    }
    localStorage.setItem(SID_KEY, JSON.stringify({ id: sid, ts: now }));
    setInterval(function () {
      try { localStorage.setItem(SID_KEY, JSON.stringify({ id: sid, ts: Date.now() })); } catch (e) {}
    }, 60000);
  } catch (e) {
    sid = 's' + Date.now().toString(36);
    newSession = true;
  }

  // ── event queue + flushing ──
  var queue = [];
  var flushTimer = null;

  function flush() {
    if (!queue.length) return;
    var payload = JSON.stringify({
      v: variant, sid: sid, pt: pageType,
      path: location.pathname.slice(0, 200),
      ev: queue.splice(0, 300)
    });
    try {
      // text/plain keeps sendBeacon CORS-simple (no preflight)
      navigator.sendBeacon(cfg.endpoint, new Blob([payload], { type: 'text/plain' }));
    } catch (e) {
      fetch(cfg.endpoint, { method: 'POST', body: payload, keepalive: true });
    }
  }

  function push(ev) {
    queue.push(ev);
    if (!flushTimer) flushTimer = setTimeout(function () { flushTimer = null; flush(); }, 45000);
  }

  // ── pageview ──
  push({ t: 'pv', ns: newSession ? 1 : 0 });

  // ── engagement time (only while tab visible) + scroll depth ──
  var engagedSecs = 0;
  var maxScroll = 0;
  setInterval(function () {
    if (document.visibilityState === 'visible') engagedSecs++;
  }, 1000);
  window.addEventListener('scroll', function () {
    var h = document.documentElement;
    var total = h.scrollHeight - h.clientHeight;
    if (total > 0) {
      var pct = Math.round(((h.scrollTop || document.body.scrollTop) / total) * 100);
      if (pct > maxScroll) maxScroll = pct;
    }
  }, { passive: true });

  var endSent = false;
  function sendEnd() {
    if (endSent) return;
    endSent = true;
    queue.push({ t: 'end', secs: engagedSecs, sc: maxScroll });
    flush();
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') { sendEnd(); endSent = false; }
  });
  window.addEventListener('pagehide', sendEnd);

  // ── click tracking: products, collections, sections, checkout ──
  function sectionKeyOf(el) {
    var sec = el.closest('.shopify-section');
    if (!sec || !sec.id) return null;
    // id: shopify-section-template--123__lab_row_2 -> lab_row_2
    var m = sec.id.match(/__([A-Za-z0-9_-]+)$/);
    return m ? m[1] : sec.id.replace(/^shopify-section-/, '').slice(0, 60);
  }

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('a[href], button[name="checkout"]') : null;
    if (!el) return;
    if (el.getAttribute && el.getAttribute('name') === 'checkout') {
      push({ t: 'co' });
      return;
    }
    var href = el.getAttribute('href') || '';
    if (!href || href[0] === '#') return;
    var path;
    try { path = new URL(href, location.origin).pathname; } catch (err) { return; }
    var key = null;
    var pm = path.match(/\/products\/([A-Za-z0-9._-]+)/);
    var cm = path.match(/\/collections\/([A-Za-z0-9._-]+)/);
    if (path.indexOf('/checkout') === 0) {
      push({ t: 'co' });
      return;
    }
    if (pm) key = 'p:' + pm[1];
    else if (cm && !pm) key = 'c:' + cm[1];
    else key = 'u:' + path.slice(0, 80);
    var sk = sectionKeyOf(el);
    push({ t: 'ck', k: key });
    if (sk && pageType === 'index') push({ t: 'ck', k: 's:' + sk });
  }, true);

  // ── add-to-cart interception + cart attribution ──
  var cartStamped = false;
  function stampCart() {
    if (cartStamped) return;
    cartStamped = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { roku_variant: variant, roku_lab_day: cfg.day || '' } })
    });
  }

  function extractVariantId(body) {
    try {
      if (body instanceof FormData) return body.get('id');
      if (typeof body === 'string') {
        var m = body.match(/(?:^|&)id=(\d+)/) || body.match(/"id"\s*:\s*"?(\d+)/);
        return m ? m[1] : null;
      }
    } catch (e) {}
    return null;
  }

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isAdd = url.indexOf('/cart/add') !== -1;
    var vid = isAdd && init ? extractVariantId(init.body) : null;
    var p = origFetch.apply(this, arguments);
    if (isAdd) {
      p.then(function (res) {
        if (res && res.ok) {
          push({ t: 'atc', k: vid ? 'vid:' + vid : 'u:' + location.pathname.slice(0, 80) });
          stampCart();
          flush();
        }
      });
    }
    return p;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__rokuAdd = typeof url === 'string' && url.indexOf('/cart/add') !== -1;
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    if (this.__rokuAdd) {
      var vid = extractVariantId(body);
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) {
          push({ t: 'atc', k: vid ? 'vid:' + vid : 'u:' + location.pathname.slice(0, 80) });
          stampCart();
          flush();
        }
      });
    }
    return origSend.apply(this, arguments);
  };
})();
